
































import { Component, Vue, Emit, Prop } from "vue-property-decorator";
import CalendarComponent from "@/components/common/parts/CalendarComponent.vue";
import SelectComponent from "@/components/common/parts/SelectComponent.vue";
import { ReportHistory } from "@/typescript/models/reports/types";
import PagenationComponent from "@/components/common/parts/PagenationComponent.vue";
export { ReportHistory };

@Component({
  components: {
    SelectComponent,
    CalendarComponent,
    PagenationComponent
  }
})
export default class ReportHistoriesMenubarComponent extends Vue {
  $refs!: {
    pagenation: PagenationComponent;
  };

  @Prop()
  reports!: ReportHistory[];

  @Prop()
  currentPageNo!: number;

  @Prop()
  showTargetDate!: string;

  @Emit()
  changeCalendar(value: Date | string) {
    return value;
  }

  @Emit()
  changePage(num: number) {
    return num;
  }

  @Emit()
  moveNextPage(isMove: boolean) {
    return isMove;
  }

  @Emit()
  movePrevPage(isMove: boolean) {
    return isMove;
  }

  getItemStartNum(): number {
    if (!this.$refs.pagenation) return 0;
    return this.$refs.pagenation.getItemStartNum();
  }

  getItemEndNum(): number {
    if (!this.$refs.pagenation) return 0;
    return this.$refs.pagenation.getItemEndNum();
  }
}
